import React, { memo } from 'react';

import type { SelectDropdownInputBaseProps } from './select-dropdown-input-base';
import SelectDropdownInputPrimary from './select-dropdown-input-base';
import SelectDropdownInputCustom from './select-dropdown-input-custom';
import SelectDropdownMinimalInput from './select-dropdown-input-minimal';
import SelectDropdownInputSecondary from './select-dropdown-input-secondary';
import { DropdownInputType } from './select-dropdown-input.types';

export interface SelectDropdownInputProps extends SelectDropdownInputBaseProps {
  type?: DropdownInputType;
}

const SelectDropdownInput = React.forwardRef<any, SelectDropdownInputProps>(
  ({ type = DropdownInputType.PRIMARY, ...inputProps }, ref) => {
    switch (type) {
      case DropdownInputType.CUSTOM:
        return <SelectDropdownInputCustom {...inputProps} ref={ref} />;
      case DropdownInputType.SECONDARY:
        return <SelectDropdownInputSecondary {...inputProps} ref={ref} />;
      case DropdownInputType.MINIMAL:
        return <SelectDropdownMinimalInput {...inputProps} ref={ref} />;
      case DropdownInputType.PRIMARY:
      default:
        return <SelectDropdownInputPrimary {...inputProps} ref={ref} />;
    }
  }
);

export default memo(SelectDropdownInput);
